import React, { ReactNode, useMemo } from 'react'
import { createTheme } from '@airbus/elements/theming'
import defaultTheme from './defaultTheme'

export type ThemeRef = string

export const ThemeContext = React.createContext(null)

type ThemeProviderProps = {
  brand?: ThemeRef
  theme?: any
  children: ReactNode
}

// TODO: use window.matchMedia() to get the result of the prefers-color-scheme media query?
// - https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia
// - https://github.com/system-ui/theme-ui/blob/master/packages/color-modes/src/index.js
export default function ThemeProvider({
  children,
  brand = 'airbus',
  // this prop is for testing purposes: it allows us to use a very simple theme and not the full one in our tests
  theme: externalTheme,
}: ThemeProviderProps) {
  const theme = useMemo(() => externalTheme || createTheme(brand), [brand, externalTheme])
  return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
}

/* This hook aims to always return a theme even if the user has not added a ThemeProvider to its app.
In that case, it will return a default theme. */
export const useTheme = () => React.useContext(ThemeContext) || defaultTheme
